import { observable } from "mobx";
import { AnswersDto } from "../../../api/questionForm/CvpGetAnswers";
import { FormQuestion } from "../../../api/questionForm/QuestionFormTypes";

export enum QuestionType {
  CHOICE = "CHOICE",
  TEXT = "TEXT",
  NUMBER = "NUMBER",
}

export const getQuestionType = (question: FormQuestion) => {
  if (question.options[0].isString) return QuestionType.TEXT;
  if (question.options[0].isNumber) return QuestionType.NUMBER;
  return QuestionType.CHOICE;
};

export const getIndentationStyle = (question: FormQuestion) => {
  const isChild = question.orderPosition.includes(".");
  if (isChild) {
    return {
      paddingLeft: "25px",
    } as React.CSSProperties;
  }
  return {} as React.CSSProperties;
};

export const validateQuestion = (
  question: FormQuestion,
  answers: AnswersDto[]
) => {
  let mandatoryIfIds = question.mandatoryIfChosenOptionIds;

  //Never mandatory
  if (!question.mandatory && mandatoryIfIds.length == 0)
    return { ok: true, type: "Never mandatory" };

  answers.forEach((answer) => {
    mandatoryIfIds = mandatoryIfIds.filter(
      (rid) => rid !== answer.questionOptionId
    );
  });

  let mandatoryConditionMet =
    question.mandatoryIfChosenOptionIds.length > 0 &&
    mandatoryIfIds.length == 0;

  //Question is only conditionally mandatory, and condition has not been met
  if (!question.mandatory && !mandatoryConditionMet)
    return { ok: true, type: "Mandatory condition has not been met" };

  const relevantAnswers = answers.filter(
    (answer) => answer.questionId == question.id
  );

  if (relevantAnswers.length != 0)
    return { ok: true, type: "Answered", answer: relevantAnswers[0] };

  return { ok: false };
};
